import React from 'react';
import { useFieldArray } from 'react-hook-form';
import { FormError, HelpText } from '@Forms/fields.jsx';
import ChevronDownIcon from '@svgs/ChevronDown.svg?react';
import ChevronUpIcon from '@svgs/ChevronUp.svg?react';
import PlusIcon from '@svgs/Plus.svg?react';
import TrashIcon from '@svgs/Trash.svg?react';

const Item = ({ fieldPrefix, index, itemsArray, register }) => {
  return (
    <div className="sb-flex">
      <input
        type="text"
        {...register(fieldPrefix, {
          required: 'This field is required',
        })}
      />
      <button
        type="button"
        className="sb-btn"
        disabled={index === 0}
        onClick={() => itemsArray.move(index, index - 1)}
      >
        <ChevronUpIcon />
      </button>
      <button
        type="button"
        className="sb-btn"
        disabled={index === itemsArray.fields.length - 1}
        onClick={() => itemsArray.move(index, index + 1)}
      >
        <ChevronDownIcon />
      </button>
      <button
        type="button"
        className="sb-btn"
        onClick={() => {
          if (window.confirm('Are you sure to delete this record?')) {
            itemsArray.remove(index);
          }
        }}
      >
        <TrashIcon />
      </button>
    </div>
  );
};

// default item data for new entries for the default Item component
//
// can be overridden by providing a defaultItemData
const defaultItem = '';

const ListItemsField = ({
  defaultItemData = defaultItem,
  ItemComponent = Item,
  control,
  error,
  helpText,
  label,
  name,
  register,
  setValue,
  options = {},
  ...props
}) => {
  // manage list of string items, serialized as ["Item 1", "Item 2"]

  const itemsArray = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormProvider)
    name: name, // unique name for your Field Array
    rules: options,
  });

  const itemsList = itemsArray.fields.map((field, index) => {
    const fieldPrefix = `${name}.${index}`;
    // nested datamodel fields
    return (
      <ItemComponent
        key={field.id}
        field={field}
        fieldPrefix={fieldPrefix}
        index={index}
        itemsArray={itemsArray}
        register={register}
        setValue={setValue}
        {...props}
      />
    );
  });

  return (
    <div
      className={
        `sb-form-item-formgroup ` + (error ? 'sb-form-item-error' : '')
      }
    >
      <label>{label}</label>
      <div className="sb-form-item-content">
        <div>
          {itemsList}
          <button
            type="button"
            className="sb-btn sb-btn-cancel"
            onClick={() => itemsArray.append(defaultItemData)}
          >
            Add <PlusIcon />
          </button>
        </div>
        {helpText && <HelpText message={helpText} />}
        {error && error.root && <FormError message={error.root.message} />}
      </div>
    </div>
  );
};

export default ListItemsField;
